import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import {
  ProviderDetailsMaestroResponse,
  StoreKeys,
  initialState,
} from './guestAcquisitionStore';

const store = (set) => ({
  ...initialState,
  [StoreKeys.IS_NAVIGATING_MAESTRO]: false,
  [StoreKeys.SET_IS_NAVIGATING_MAESTRO]: (isNavigatingMaestro: boolean) =>
    set({ isNavigatingMaestro }),
  [StoreKeys.IS_NAVIGATING_FROM_JARVIS]: false,
  [StoreKeys.SET_IS_NAVIGATING_FROM_JARVIS]: (
    isNavigatingFromJarvis: boolean
  ) => set({ isNavigatingFromJarvis }),
  [StoreKeys.REQUEST_DATA]: {},
  [StoreKeys.SET_REQUEST_DATA]: (requestData: any) => set({ requestData }),
  [StoreKeys.CLEAR_REQUEST_DATA]: () => set({ requestData: {} }),
  [StoreKeys.RESPONSE_DATA]: [],
  [StoreKeys.SET_RESPONSE_DATA]: (
    responseData: ProviderDetailsMaestroResponse[]
  ) => set({ responseData }),
  [StoreKeys.CLEAR_RESPONSE_DATA]: () => set({ responseData: [] }),
  [StoreKeys.IS_UPDATE_PROVIDER]: false,
  [StoreKeys.SET_IS_UPDATE_PROVIDER]: (isUpdateProvider: boolean) =>
    set({ isUpdateProvider }),
  [StoreKeys.REFERRING_URL]: '',
  [StoreKeys.SET_REFERRING_URL]: (referringUrl: string) =>
    set({ referringUrl }),
});

const guestAcquisitionStore = persist(store, {
  name: 'guestAcquisitionStore',
  storage: createJSONStorage(() => sessionStorage),
  merge: (persistedState, currentState) => ({
    ...currentState,
    ...persistedState,
  }),
}) as any;

export const useGuestAcquisitionStore = create(devtools(guestAcquisitionStore));
